import { render, staticRenderFns } from "./GiveTrust.vue?vue&type=template&id=6a7652ee&scoped=true"
import script from "./GiveTrust.vue?vue&type=script&lang=js"
export * from "./GiveTrust.vue?vue&type=script&lang=js"
import style0 from "./GiveTrust.vue?vue&type=style&index=0&id=6a7652ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7652ee",
  null
  
)

export default component.exports